(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lilbi-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lilbi-logo-marquee')) {
    customElements.define('lilbi-logo-marquee', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      init() {
        this.viewport = this.querySelector('.lilbi-logos__viewport');
        this.track = this.querySelector('.lilbi-logos__track');
        this.source = this.querySelector('[data-source]');
        if (!this.source || !this.source.children.length) return;

        this.observer = new ResizeObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.build());
        });
        this.observer.observe(this.viewport);
        this.build();
      }

      makeCopy(node) {
        const copy = node.cloneNode(true);
        copy.setAttribute('data-copy', '');
        copy.setAttribute('aria-hidden', 'true');
        // Repeated logos keep working with a pointer, without duplicate tab stops.
        copy.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
        copy.querySelectorAll('img').forEach(image => image.setAttribute('alt', ''));
        [copy, ...copy.querySelectorAll('*')].forEach(element => {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
        });
        return copy;
      }

      build() {
        if (!this.isConnected) return;
        this.removeAttribute('data-ready');
        this.track.querySelectorAll('[data-copy]').forEach(copy => copy.remove());
        const originals = [...this.source.children];
        const cycleWidth = this.source.getBoundingClientRect().width;
        const viewportWidth = this.viewport.clientWidth;
        if (!cycleWidth || !viewportWidth) return;

        // Fill one full viewport before duplicating the entire group.
        // End padding equals the gap, so the loop boundary has the same spacing.
        const repetitions = Math.ceil(viewportWidth / cycleWidth);
        for (let i = 1; i < repetitions; i++) {
          originals.forEach(item => this.source.append(this.makeCopy(item)));
        }
        const groupWidth = this.source.getBoundingClientRect().width;
        const speed = Math.max(10, Number(this.dataset.speed) || 35);
        this.style.setProperty('--ll-duration', `${groupWidth / speed}s`);
        const secondGroup = this.makeCopy(this.source);
        secondGroup.removeAttribute('data-source');
        this.track.append(secondGroup);
        this.setAttribute('data-ready', '');
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
